import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DefaultDistribution, ApplyToAllResponse } from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from '../api.service.abstract';

type EntityResponseType = HttpResponse<DefaultDistribution>;

@Injectable({ providedIn: 'root' })
export class DefaultDistributionService extends ApiService<DefaultDistribution> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'distribution/api/default-distributions');
  }

  getByProfileId(
    commissionProfileId: number
  ): Observable<EntityResponseType> {
    return this.http.get<DefaultDistribution>(
      `${this.url}/${this.endpoint}/profile/${commissionProfileId}`,
      {
        observe: 'response',
      }
    );
  }

  /**
   * Default distributions of every profile of the company (each item
   * carries `commissionProfileId`). Profiles without one are simply absent
   * from the response (no 404, unlike `getByProfileId`).
   */
  getByCompany(
    companyId: number | string
  ): Observable<HttpResponse<DefaultDistribution[]>> {
    return this.http.get<DefaultDistribution[]>(
      `${this.url}/${this.endpoint}/company/${companyId}`,
      {
        observe: 'response',
      }
    );
  }

  applyToAll(
    commissionProfileId: number
  ): Observable<HttpResponse<ApplyToAllResponse>> {
    return this.http.put<ApplyToAllResponse>(
      `${this.url}/${this.endpoint}/profile/${commissionProfileId}/apply-to-all`,
      {},
      {
        observe: 'response',
      }
    );
  }
}
